export default __webpack_public_path__ + "static/media/2.720c1cd7.png";